<template>
    <div>
    <!-- DIALOGS -->
        <ExportDialog />
        <DeletionDialog :context="'Selected' + context" />
        <SelectionRequiredDialog />
        <MoveIntoCompanyDialog 
            :context="context"
            :message="$t('lang_CONTRACTS_LABEL_CAPTION_MOVE_CONTRACTS_TEXT')"
        />
        <ManageTagsDialog 
			:context="context"
			dir='contracts/publishing'
			idAttributeName='alvIds'
		/>
        <!-- Action: COPY CONDITIONS DIALOG -->
		<SearchDialog
			:context="context"
			:searchcontext="'CopyConditionsFor' + context"
			subcontext="Contracts"
			:addcontext="'CopyConditionsTo' + context"
			addButtonLabel="lang_GENERIC_CAPTION_APPLY"
			dialogTitle="lang_CONTRACTS_PUBLISHING_CAPTION_APPLY_CONDITIONS"
			:alvqaContext="alvqa + '-list'"
		>
			<!-- <template v-slot:selectAllText="{ items }">
				{{ contractsFoundSelectedText(items.items, items.selected) }}
			</template> -->

			<template v-slot:itemTitle="{ item }">
				{{ item.title }} ({{ item.alvId }})
			</template>
			<template v-slot:itemSubtitle="{ item }">
				{{ item.licensor.gemaName }}
			</template>

            <template v-slot:additionalContent>
                <v-divider class="mb-4"></v-divider>
                <v-row>
                    <v-col cols="4">
                        <v-text-field 
                            v-model="tagsForCopyConditions"
                            :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                            :alvqa="alvqa + '-action-copy-conditions-search-dialog-textfield-tags'"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="8" class="d-flex align-center">
                        <v-checkbox
                            v-model="adaptRecipientFlag"
                            :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_ADAPT_RECIPIENT_TO_CONTRACTING_PARTNER')"
                            :alvqa="alvqa + '-action-copy-conditions-search-dialog-checkbox-adapt-recipient'"
                            color="buttonStandard"
                            hide-details
                        />
                    </v-col>
                </v-row>
            </template>
            <template v-slot:additionalButtons v-if="showDownloadCsvForCopyConditions">
                <div class="mr-4 d-inline-block">
                    <BaseTooltip 
                        simpleText="lang_GENERIC_CAPTION_DOWNLOAD_CSV_REPORT"
                        :alvqa="alvqa + '-action-copy-conditions-search-dialog-icon-download-csv-report-caption'"
                    />
                    <BaseIcon 
                        @click.stop="downloadReport()" 
                        icon="cloud_download"
                        :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                        :alvqa="alvqa + '-action-copy-conditions-search-dialog-icon-download-csv-report-button'" 
                    />
                </div>
            </template>
		</SearchDialog>
        <ConfirmationDialog />
        <GroupDialog />
    <!-- LIST PAGE COMPONENT -->
        <BaseListPage
            headline="lang_CONTRACTS_PUBLISHING_CONTRACTS"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
        >

        <template v-slot:filter>
            <v-col cols="2">
                <DropdownFilter 
                    :context="context + 'QualityFilter'"
                    label="lang_GENERIC_CAPTION_QUALITY"
                    :items="qualityItems"
                    :alvqa="alvqa + '-list-dropdown-quality'"
                />
            </v-col>
        </template>

        <!-- DATA TABLE COMPONENT-->
            <template v-slot:dataTable>
                <BaseDataTableList 
                    :headers="headers"
                    :context="context" 
                    :alvqa="alvqa"       
                    :hasServerSideSorting='true'
                    :stickyTopSlot="true"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                <template v-slot:topSlot><PublishingContractsTopSlot /></template>
                <!-- DATA TABLE CONTENT: columns -->
                    <template v-slot:body="{ item }">
						<ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alvid'"
                        >
                            {{ item.item.alvId }}
                            <BaseTooltip v-if="item.item.groupName !== null && item.item.groupName !== undefined">
                                <template v-slot:text>
                                    {{ $t('lang_PUBLISHING_CONTRACTS_GROUPED_CONTRACTS') }}{{ item.item.groupName ? ': ' + item.item.groupName : '' }}
                                </template>
                                <template v-slot:content>
                                    <v-icon small color="grey darken-1" class="ml-1" style="transform:rotate(90deg)">linear_scale</v-icon>
                                </template>
                            </BaseTooltip>
                        </td>
						<td class="ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.contractName" 
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-name'"
                            />
                        </td>
                        
                        <td 
                            class="ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contracting-party'"
                        >
                            <BaseTooltip>
                                <template v-slot:text>
                                    {{ item.item.licensor !== null ? $alvPlugin.showNameOfAzEntry(item.item.licensor)+ ' (' + $t('lang_GENERIC_CAPTION_ALVID') +': ' + item.item.licensor.alvId + ' | ' + 
                                     getIPI(item) + ' | ' + getKTO(item)  +  ')' : '' }}
                                </template>
                                <template v-slot:content>
                                    {{ $alvPlugin.showNameOfAzEntry(item.item.licensor) }}                               
                                </template>
                            </BaseTooltip>
                        </td>
                        
                        <td 
                            class="ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-type'"
                        >
                            <!-- {{ $t(getContractType(item.item.contractType)) }} -->
                            {{ item.item.contractType }}
                        </td>
                        <td 
                            class="no_ellipsis text-right"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-number-of-assigned-works'"
                        >{{ $n(item.item.numberOfAssignedWorks, 'numberInteger') }} {{ $t(getWorksLangConst(item.item.numberOfAssignedWorks)) }}</td>
                        <td 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-contract-date'"
                        >{{ item.item.contractDate !== null ? $d(new Date(item.item.contractDate), 'alvDateFormat') : '' }}</td>
                    </template>
				<!-- EXPAND: Read Only View -->
					<template v-slot:expandSlot="{ id }"><PublishingContractsReadOnly :itemId='id' /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseIcon from '@/components/_buttons/BaseIcon'

import PublishingContractsTopSlot from './PublishingContractsTopSlot'
import PublishingContractsReadOnly from './_readonly/PublishingContractsReadOnly'

import DropdownFilter from '@/components/_filters/DropdownFilter'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SearchDialog from '@/components/_dialogs/SearchDialog'
import MoveIntoCompanyDialog from '@/components/_dialogs//MoveIntoCompanyDialog'
import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import ExportDialog from './_dialogs/ContractsPublishingExportDialog'
import GroupDialog from './_dialogs/PublishingContractsGroupDialog'
import ConfirmationDialog from '@/components/_dialogs/ConfirmationDialog'
import api from '@/api_alv'

export default {
    name: "PublishingContractsList",  
    components: {
		BaseListPage,
        BaseDataTableList,
        BaseTooltip,
        ExpandIcon,
        BaseIcon,
        
        PublishingContractsTopSlot,
        PublishingContractsReadOnly,
        DropdownFilter,
        DeletionDialog,
        SearchDialog,
        MoveIntoCompanyDialog,
        SelectionRequiredDialog,
        ManageTagsDialog,
        ExportDialog,
        GroupDialog,
        ConfirmationDialog
    },
    data() {
        return {
            context: "PublishingContracts",
            alvqa: 'contracts-publishing'
        }
    },
    computed: {
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, sortable: string, value: string}]} props of the header */
        headers() {
            return [   
				{
					text: '', 
					value: 'data-table-select', 
                    sortable: false,
					width: "60px"
				},
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
					sortable: false,
					class: 'text-no-wrap'
				},
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'), 
					value: 'alvId', 
					align: 'left', 
					sortable: false,
					width: "165px",
					class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CONTRACT_TITLE'), 
                    value: 'contractName', 
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY'), 
                    value: 'licensor',
                    align: 'left', 
                    sortable: true, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE'), 
                    value: 'contractType', 
                    align: 'left', 
                    sortable: true, 
                    width: "130px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_CONNECTED_TO'), 
                    value: 'numberOfAssignedWorks',
                    align: 'right', 
                    sortable: false,
                     width: "175px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_DATE'), 
                    value: 'contractDate',
                    align: 'left', 
                    sortable: false, 
                    width: "145px",
                    class: 'text-no-wrap'
                },
                {
					text: '', 
					value: 'ghost',
					sortable: false,
                    class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
            ]
        },
        qualityItems() {
            return[ 
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_SEARCH_QUALITY_NO_SPLITS'), 
                    value: 'noSplits',
                    alvqa: this.alvqa + '-list-dropdown-quality-nosplits'
                },
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_SEARCH_QUALITY_NO_CONDITIONS'), 
                    value: 'noConditions',
                    alvqa: this.alvqa + '-list-dropdown-quality-noconditions'
                },
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_SEARCH_QUALITY_NO_WORKS'), 
                    value: 'noWorks',
                    alvqa: this.alvqa + '-list-dropdown-quality-noworks'
                },
                {
                    text: this.$t('lang_PUBLISHING_CONTRACTS_CAPTION_QUALITY_IS_GROUPED'), 
                    value: 'isGrouped',
                    alvqa: this.alvqa + '-list-dropdown-quality-isgrouped'
                },
            ]
        },
        downloadCsvPathForCopyConditions() {
            return this.$store.getters.getCopyConditionsForPublishingContractsCsvPath
        },
        showDownloadCsvForCopyConditions() {
            let csvPath = this.downloadCsvPathForCopyConditions
            
            return csvPath !== null && csvPath !== ""
        },
        tagsForCopyConditions: {
            get() { return this.$store.getters.getCopyConditionsForPublishingContractsTags },
            set(value) { this.$store.commit('setCopyConditionsForPublishingContractsTags', value) }
        },
        adaptRecipientFlag: {
            get() { return this.$store.getters.getCopyConditionsForPublishingContractsAdaptRecipient },
            set(value) { this.$store.commit('setCopyConditionsForPublishingContractsAdaptRecipient', value) }
        }
    },
    methods: {
        // getContractType(contractTypeValue) {
        //     let match = this.$store.getters.getPublishingContractsTypes.find(type => {
        //         return type.value === contractTypeValue
        //     })

        //     if(match !== undefined) return match.text
        //     else ''
        // }
        getIPI(item){
            let temp = item.item.licensor.ipi

            if(temp === null){
                temp = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
            return this.$t('lang_GENERIC_AZ_CAPTION_IPI') + ': '+ temp
        },
        getKTO(item){
            let yKTO = item.item.licensor.ykto 
            let hKTO = item.item.licensor.hkto
            let uKTO = item.item.licensor.ukto

            if(yKTO === null){
                 yKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')
            }
            if(hKTO === null){
               hKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') 
            }
            if(uKTO === null){
               uKTO = this.$t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') 
            }

            return this.$t('lang_GENERIC_CAPTION_KTO') + ': ' + yKTO + ' - ' + hKTO + ' - ' + uKTO
        },
        getWorksLangConst(amount) {
            if(amount === 0 || amount > 1) return "lang_GENERIC_WORKS_PLURAL"
            else return "lang_GENERIC_WORKS_SINGULAR"
        },
        downloadReport() {
            api.getFileFromALV(this.downloadCsvPathForCopyConditions)
            this.$store.commit('setCopyConditionsForPublishingContractsCsvPath', null)
        }
    },
    created() {
        this.$store.commit('setPublishingContractsTypes')
    },
}
</script>